var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-all"},[(_vm.isCompanyUser)?_c('div',[_c('course-company')],1):_c('div',[_c('course-app')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }